require.register("modules/m02s/m02s-activity/page-14-co/page-14-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page14co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page14co;

  
});

